import { T }             from 'defa-object';
import ControlModule     from 'scripts/poppet/control-module';
import { SingleEvent }   from 'scripts/utils/single-event';
import { Program }       from 'scripts/utils/program';
import template          from 'templates/controlCalendarEntries.jst.html';
import { Vue }           from 'vue/defavue';
import vueTemplate       from './view-control-calendar-entries-view.vue.html';


const selectors = {
	toggleButton    : '[data-toggle=expand-spoiler]',
	region: '[data-region=calendar-entries-container]',
};

const actionOptions     = [
	{ value: 'ON', title: T.tc( 'CalendarEntries', 'Home' ), titleContext: 'Heating' },
	{ value: 'OFF', title: T.tc( 'CalendarEntries', 'Away' ), titleContext: 'Heating' }
];

export const ControlCalendarEntriesView = ControlModule.extend( {
	template,
	expandedNavState  : 'unit:control:calendar',
	compressedNavState: 'unit:control:overview',

	ui: {
		toggle          : selectors.toggleButton,
		region: selectors.region,
	},

	events: {
		'click @ui.toggle'          : 'onClickToggle', // super
	},

	className() {
		return this._getClassName( 'control-calendar' );
	},
	
	onDomRefresh() {
		let self   = this;
		let region = this.ui.region[ 0 ];
		console.log( region );


		let nextEvent = new Vue( {
			el: '#next-event',
			bb() {
				return {
					model: self.model
				};
			},
			data() {
				return {};
			},
			computed: {
				nextEvent() {
					const singleEvents = this.model.calendarEntries
						.map(p => new SingleEvent(new Date(p.dateTime), p.mainSwitch));
					const now = new Date();
					return Program.nextTime( singleEvents, now );
				},
			}
			
		});
		
		let calendarEntriesComponent = new Vue( {
			template: vueTemplate,
			bb() {
				return {
					model: self.model
				};
			},
			data() {
				return {
					showInfo : false,
					actionOptions,
					warningText : "",
					editingIndex : null,
					editingObject: null,
					calendarEntriesValue: [],
				};
			},
			computed: {
				canAddMore() {
					return this.model.calendarEntries.length < this.model.maxCount;
				},

				programs() {
					return this.model.calendarEntries;
				},

				getMaxDate() {
					if(!this.editingObject) {
						return '0000-00-00';
					}
					//Set max date one year minus one day ahead
					let date = new Date(this.editingObject.date+'T'+ this.editingObject.time);
					date.setFullYear(date.getFullYear() + 1);
					date.setDate(date.getDate() - 1);
					return date.format('yyyy-mm-dd');
				},

				getMinDate() {
					//Set min date to today
					return new Date().format('yyyy-mm-dd');
				},

				canSave( ) {
					let now = new Date();
					let date = new Date(this.editingObject.date + 'T' + this.editingObject.time);
					if(date.getTime() <= now.getTime()) {
						this.warningText = 'Time must be in the future';
						return false;
					}
					this.warningText = '';
					if( this.editingObject === null) {
						return false;
					}

					if ( this.editingIndex === this.calendarEntriesValue.length ) {
						//New object
						return true;
					}

					return (this.editingObject.time !== this.calendarEntriesValue[ this.editingIndex ].time ||
							this.editingObject.date !== this.calendarEntriesValue[ this.editingIndex ].date ||
							this.editingObject.mainSwitch !== this.calendarEntriesValue[ this.editingIndex ].mainSwitch);
				},
			},
			
			watch: {
				'model.calendarEntries': function ( newAttribute ) {
					this.calendarEntriesValue = JSON.parse(JSON.stringify(_.sortBy(newAttribute, 'time')));
				}
			},

			methods : {
				addRow() {
					let inOneHour = new Date();
					inOneHour.setHours(inOneHour.getHours() + 1);
					let time = inOneHour.toTimeString().slice(0, 5);
					let date = inOneHour.format('yyyy-mm-dd');
					this.editingObject = { time: time, date: date, mainSwitch: 'OFF'};
					this.editingIndex  = this.calendarEntriesValue.length;
				},

				deleteRow(index) {
					if ( index < this.calendarEntriesValue.length ) {
						this.calendarEntriesValue.splice( index, 1 );
						this.$emit( 'save', this.calendarEntriesValue  );
					}
				},
				
				cancelEditing() {
					this.editingObject = null;
					this.editingIndex  = null;
				},
				
				saveRow() {
					if ( this.editingIndex === this.calendarEntriesValue.length ) {
						this.calendarEntriesValue.push( this.editingObject );
					} else {
						Object.assign( this.calendarEntriesValue[ this.editingIndex ], this.editingObject );
					}

					this.cancelEditing();
					this.$emit( 'save', this.calendarEntriesValue  );
					
				},
				
				editRow( index ) {
					this.editingIndex  = index;
					this.editingObject = Object.assign( {}, this.calendarEntriesValue[ index ] );
				},

				dateDisplay( dateTime ) {
					return new Date(dateTime).format( T.dateFormatLong );
				},

				infoClicked() {
					this.showInfo = !this.showInfo;
				},
				created() {
					this.calendarEntriesValue = JSON.parse(JSON.stringify(_.sortBy(this.model.calendarEntries, 'time')))
				}
			}
		} );
		
		calendarEntriesComponent.$mount( region );
		calendarEntriesComponent.$on( 'save', ( attribute ) => {
			let self = this;
			self.model.set('isValidData', false);
			let payload = this.model.attributeToRequestPayload(attribute);
			try {
				this.model.save(payload, {
					patch: true,
					isSaving: true,
					success: function() {
						console.log( Object.keys(attribute)[0] +' was succesfully saved!' );
					},
					error: function(model, response) {
						console.error( Object.keys(attribute)[0] + ' failed saving with error: ' + response.responseJSON.message );
					}
				});
			} catch ( err ) {
				console.error( err );
				setTimeout( () => this.idle(), 1000 );
			}
		} );
	}
} );

export default ControlCalendarEntriesView;
